import { render, staticRenderFns } from "./ActivityComments.vue?vue&type=template&id=30d7d4ff&scoped=true&"
import script from "./ActivityComments.vue?vue&type=script&lang=js&"
export * from "./ActivityComments.vue?vue&type=script&lang=js&"
import style0 from "./ActivityComments.vue?vue&type=style&index=0&id=30d7d4ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d7d4ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d7d4ff')) {
      api.createRecord('30d7d4ff', component.options)
    } else {
      api.reload('30d7d4ff', component.options)
    }
    module.hot.accept("./ActivityComments.vue?vue&type=template&id=30d7d4ff&scoped=true&", function () {
      api.rerender('30d7d4ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/ActivityComments.vue"
export default component.exports